<template>
    <div class="homePage">
        <div class="title">报名信息</div>
        <el-row style="background-color: rgb(252, 252, 252)">
            <el-col :span="24">
                <el-form ref="form" :model="form" style="padding:37px 0px 37px 50px;" label-width="80px">
                    <el-col :span="12">
                        <el-form-item label="赛事组别">
                            <el-select v-model="form.group" placeholder="请选择赛事组别">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="参赛渠道">
                            <el-select v-model="form.type" placeholder="请选择参赛渠道">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="指导老师">
                            <el-input style="width:44%" placeholder="请输入指导老师姓名" v-model="form.name">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
        <div class="title">主创设计师</div>
        <el-row style="background-color: rgb(252, 252, 252)">
            <el-col :span="24">
                <el-form ref="form" :model="form" style="padding:37px 0px 37px 50px;" label-width="80px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名">
                                <el-input style="width:44%" placeholder="请输入姓名" v-model="form.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="性别">
                                <el-radio-group v-model="form.resource">
                                    <el-radio label="男"></el-radio>
                                    <el-radio label="女"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col :span="12">
                        <el-form-item label="国籍">
                            <el-select v-model="form.country" placeholder="请选择国籍">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件类型">
                            <el-select v-model="form.idcard" placeholder="请选择证件类型">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证件号码">
                            <el-input style="width:44%" placeholder="请输入证件号码" v-model="form.idnumber"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话">
                            <el-input style="width:44%" placeholder="请输入联系电话" v-model="form.phone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="联系地址">
                            <el-input placeholder="请输入联系地址" style="width:74%" v-model="form.adress"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
        <div class="title">参赛作品</div>
        <el-form ref="form" :model="form" style="padding:37px 0px 37px 50px;" label-width="80px">
            <el-form-item label="项目名称">
                <el-select v-model="form.project" placeholder="请选择赛事组别">
                    <el-option label="区域一" value="shanghai"></el-option>
                    <el-option label="区域二" value="beijing"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="项目说明">
                <el-input type="textarea" v-model="form.dess"></el-input>
            </el-form-item>
        </el-form>
        <div class="title">参赛图片</div>
        <el-form ref="form" :model="form" style="padding:37px 0px 37px 50px;" label-width="80px">
            <el-form-item label="作品图片">
                <el-upload class="upload-demo" accept=".jpg .jpeg .png" drag
                    action="https://jsonplaceholder.typicode.com/posts/" multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">支持jpg.jpeg.png格式的图片，且不超过5M</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <div style="display:flex;width:190px;margin:auto;margin-top:30px;">
            <div class="cancel" @click="back">上一步</div>
            <div class="next" @click="submit">确定</div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            tab: 1,
            accout: '257364527@qq.com',
            num: 13688888888,
            type: '个人',
            form: {
                name: '',
                group: '',
                type: '',
                project: '',
                des: '',
            }
        };
    },
    methods: {
        back() {
            this.$emit('step', 1)
        },
        submit() {

        }
    },
};
</script>

<style lang="scss" scoped>
.homePage {
    text-align: start;
    color: black;
    width: 1200px;
    margin: auto;

    .title {
        padding-left: 15px;
        font-size: 20px;
        border-left: 2px solid rgb(37, 135, 125)
    }

    .basic {

        background-color: rgb(252, 252, 252)
    }

    .cancel,
    .next {
        width: 94px;
        height: 38px;
        margin-right: 5px;
        cursor: pointer;
        background-color: rgb(228, 228, 228);
        text-align: center;
        line-height: 38px;
        border-radius: 5px;
    }

    .next {
        color: white;
        background-color: rgb(37, 135, 125)
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Signup/business2.vue